import { TransferDetailsComponent } from './transfer-details.component';
import { Routes } from '@angular/router';

export const TRANSFERS_ROUTES: Routes = [
    {
        path: '',
        component: TransferDetailsComponent,
        data: { section: "TEAM_TRANSFERS_DETAILS", backEnabled: true }
    }
];
